import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { Details } from '@/components/JobView'
import { getJob } from '@/redux/jobs/thunk'

const DetailsContainer = () => {
  const dispatch = useDispatch()
  const { job } = useSelector((state) => state.jobsReducer)

  const { jobId } = useParams()

  useEffect(() => {
    if (jobId) {
      dispatch(getJob(jobId))
    }
  }, [jobId, dispatch])

  return <Details data={job} />
}

export default DetailsContainer
